import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RegionManagementComponent } from './region-management.component';

const routes: Routes = [
  { 
   path: '',
    children: [
      {
        path: 'default',
        component: RegionManagementComponent,
        data: {
          title: "Region Management",
          breadcrumb: "Region Management"
        }
      }
    ],
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegionManagementRoutingModule { }
